import { render, staticRenderFns } from "./EarMark.vue?vue&type=template&id=d48530a2&scoped=true"
import script from "./EarMark.vue?vue&type=script&lang=ts"
export * from "./EarMark.vue?vue&type=script&lang=ts"
import style0 from "./EarMark.vue?vue&type=style&index=0&id=d48530a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48530a2",
  null
  
)

export default component.exports